<template>
  <div>
    <div class="candidate-card-wrapper">
      <div @click="showFullProfile" class="float-button">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="icon-class-view" v-on="on">visibility</v-icon>
          </template>
          <span>View Profile</span>
        </v-tooltip>
      </div>
      <div
        class="float-button"
        v-if="all && !reject && !fav && !company_id"
        @click="onClickReject()"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="icon-class-reject" v-on="on">delete_outline</v-icon>
          </template>
          <span>Reject</span>
        </v-tooltip>
      </div>
      <div
        class="float-button"
        style=""
        v-if="all && !fav && !reject && !company_id"
        @click="onClickFav()"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="icon-class-save" v-on="on">favorite_border</v-icon>
          </template>
          <span>Short list</span>
        </v-tooltip>
      </div>
      <div
        class="float-button"
        v-if="!all && fav && !reject && !company_id"
        @click="onClickCancelFav()"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="icon-class-reject" v-on="on">close</v-icon>
          </template>
          <span>Remove from short list</span>
        </v-tooltip>
      </div>
      <div
        class="float-button"
        v-if="!all && !fav && reject && !company_id"
        @click="onClickCancelReject()"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="icon-class-reject" v-on="on">close</v-icon>
          </template>
          <span>Remove from reject</span>
        </v-tooltip>
      </div>
      <div v-if="!company_id" class="float-button">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon @click="onClickContact" class="icon-class-view" v-on="on"
              >mdi-email-outline</v-icon
            >
          </template>
          <span>Contact</span>
        </v-tooltip>
      </div>
      <div class="row candidate-card">
        <div
          v-if="score >= 0"
          class="col-2 col-md-12 col-lg-5 col-xl-2 information-prog my-auto  no-padding"
        >
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="score"
            :color="matchColor"
          >
            <span style="font-size: 2rem; font-weight: bold">{{
              score + "%"
            }}</span>
            <div style="font-size: 1.2rem; text-align: center">Match</div>
          </v-progress-circular>
        </div>
        <div class="col-10 col-md-12 col-lg-6 col-xl-9 information no-padding">
          <div @click="showFullProfile" class="name">{{ name }}</div>
          <div v-if="position" class="position">
            <span
              ><v-icon
                style="font-size: 2.0rem; margin-right: .7rem; margin-bottom: .3rem; margin-top: .2rem"
                >card_travel</v-icon
              ></span
            >{{ position }}
          </div>
          <div v-if="edu_ql" class="position">
            <span
              ><v-icon
                style="font-size: 2.0rem; margin-right: .7rem; margin-bottom: .3rem; margin-top: .2rem"
                >school</v-icon
              ></span
            >{{ edu_ql }}
          </div>
          <div v-if="y_of_ex" class="company">
            <span
              ><v-icon
                style="font-size: 2.0rem ;margin-right: .7rem; margin-top: .2rem"
                >mdi-seal</v-icon
              ></span
            >
            {{ y_of_ex }} year(s) of experience
          </div>
          <div v-if="gender" class="company">
            <span
              ><v-icon
                style="font-size: 2.0rem ;margin-right: .7rem; margin-bottom: .1rem; margin-top: .2rem"
                >person</v-icon
              ></span
            >{{ gender }}
          </div>
          <div class="company" v-if="location">
            <span
              ><v-icon
                style="font-size: 2.0rem ;margin-right: .7rem; margin-bottom: .1rem; margin-top: .2rem"
                >pin_drop</v-icon
              ></span
            >
            {{ location }}
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      max-width="130.0rem"
      v-model="openBox"
      @keydown.esc="openBox = false"
      v-if="!phone"
    >
      <div
        :key="change"
        style="max-height: 90vh; overflow-y: scroll; background-color: #ffffff"
      >
        <applicant-details
          v-bind:job_id="jobID"
          v-bind:candidate="candidate_details"
          v-on:close-box="openBox = false"
          v-bind:cvBank="cvBank"
        ></applicant-details>
      </div>
    </v-dialog>
    <v-dialog
      scrollable
      transition="dialog-bottom-transition"
      v-model="openBox"
      @keydown.esc="openBox = false"
      v-else
    >
      <div
        :key="change"
        style="max-height: 90vh; overflow-y: scroll; background-color: #ffffff;"
      >
        <phone-profile
          v-bind:candidate="candidate_details"
          @close="openBox = false"
        ></phone-profile>
      </div>
    </v-dialog>

    <message-box
      :key="messageChange"
      v-bind:open="openMessageBox"
      v-bind:receiver="candidate_details"
      v-bind:jobId="jobID"
      v-bind:sub-lists="subjects"
      v-bind:selected-subject="selectedTitle"
      v-on:send-message="sendMessage"
    ></message-box>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right:1.0rem"
          ><v-icon color="rgba(0,0,0,0.5)">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import ApplicantDetails from "../candidates/candidate-details";
import MessageBox from "../../global-components/message-box";
import { CANDIDATE_DETAILS } from "../../../Api/employer_api";
import { SEND_NEW_MESSAGE } from "../../../Api/common_api";
import { PHONE } from "../../../globalFunctions";
import PhoneProfile from "../candidates/phone-profile";
import { FIRST_LETTER_CAPITAL } from "../../../filters";
export default {
  name: "applicant-synopsis",
  components: {
    ApplicantDetails,
    MessageBox,
    PhoneProfile
  },
  props: {
    candidate: Object,
    type: String,
    job_id: String,
    subjects: Array,
    job: Object,
    cvBank: Boolean,
    company_id: String
  },
  data: function() {
    return {
      phone: PHONE(),
      all: false,
      fav: false,
      reject: false,
      jobID: "",
      img: null,
      name: null,
      position: null,
      edu_ql: null,
      y_of_ex: null,
      gender: null,
      location: null,
      openBox: false,
      applicantStatus: null,
      items: [
        {
          title: "Full Profile",
          action: this.showFullProfile,
          icon: "mdi-account",
          color: "#2977c9"
        }
      ],
      change: 0,
      candidate_details: null,
      openMessageBox: false,
      messageChange: 0,
      bgColor: "#454545",
      timeOut: 1500,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      score: null,
      matchColor: "#cccccc",
      selectedTitle: null
    };
  },
  methods: {
    phoneview() {
      if (this.phone) {
        const self = this;
        CANDIDATE_DETAILS(self.candidate, self.jobID)
          .then(function(data) {
            self.candidate_details = {
              ...self.candidate,
              ...data
            };
            self.$router
              .push({
                name: "PhoneProfile",
                params: { details: self.candidate_details }
              })
              .catch(function() {});
          })
          .catch(function() {
            self.$emit("error-fetch");
          });
      }
    },
    showFullProfile() {
      const self = this;
      CANDIDATE_DETAILS(self.candidate, self.jobID)
        .then(function(data) {
          self.candidate_details = {
            ...self.candidate,
            ...data
          };
          self.change++;
          self.openBox = true;
        })
        .catch(function(err) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
          self.$emit("error-fetch");
        });
    },
    onClickFav() {
      this.$emit("favourite", this.candidate.user_id);
    },
    onClickCancelFav() {
      this.$emit("cancel-favourite", this.candidate.user_id);
    },
    onClickReject() {
      this.$emit("reject", this.candidate.user_id);
    },
    onClickCancelReject() {
      this.$emit("cancel-reject", this.candidate.user_id);
    },
    onClickContact() {
      const self = this;
      self.messageChange++;
      self.openMessageBox = true;
    },
    sendMessage(message) {
      const self = this;
      self.openMessageBox = false;
      self.messageChange++;
      SEND_NEW_MESSAGE(message)
        .then(function(response) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
        })
        .catch(function(err) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    }
  },
  mounted() {
    const self = this;
    if (self.job) {
      self.selectedTitle = self.job.job_title;
    }
    if (self.job_id) {
      self.jobID = self.job_id;
    }
    if (self.candidate) {
      self.candidate_details = self.candidate;
      self.name = FIRST_LETTER_CAPITAL(self.candidate.user_name);
      self.score = Math.round(self.candidate.score * 100);
      if (self.score > 75) {
        self.matchColor = "green";
      } else if (self.score > 50) {
        self.matchColor = "#2eb5da";
      } else if (self.score > 25) {
        self.matchColor = self.$constants.SNACKBAR_COLOR.WARNING;
      } else {
        self.matchColor = self.$constants.SNACKBAR_COLOR.ERROR_ALT;
      }
      if (self.candidate.company_name) {
        if (self.candidate.title) {
          self.position =
            FIRST_LETTER_CAPITAL(self.candidate.title) +
            ", " +
            FIRST_LETTER_CAPITAL(self.candidate.company_name);
        }
      }
      if (self.candidate.institution_name) {
        if (self.candidate.degree_name) {
          self.edu_ql =
            FIRST_LETTER_CAPITAL(self.candidate.degree_name) +
            ", " +
            FIRST_LETTER_CAPITAL(self.candidate.institution_name);
        }
      }
      if (self.candidate.year_of_exp) {
        self.y_of_ex = self.candidate.year_of_exp;
      }
      self.gender = self.candidate.gender;
      self.location = self.candidate.location_name
        ? self.candidate.location_name
        : null;
      if (self.type) {
        switch (self.type) {
          case "all":
            self.all = true;

            break;
          case "fav":
            self.fav = true;

            break;
          case "rjct":
            self.reject = true;
            break;
          default:
        }
        self.items.push({
          title: "Contact",
          action: self.onClickContact,
          icon: "mdi-email",
          color: "#2977c9"
        });
      }
    }
  }
};
</script>

<style scoped>
.float-button {
  float: right;
  margin-left: 1rem;
}
.gender {
  font-size: 1.2rem;
  padding: 0.2rem 0.8rem;
  background-color: var(--synop-select-color);
  color: var(--button-color);
  margin-left: 1rem;
  border-radius: 0.2rem;
}
.noDisplay {
  display: none;
}
.icon-resize {
  height: 2.5rem;
  width: 2.5rem;
  margin-top: -0.5rem;
}
.propic {
  height: 100%;
  width: 100%;
  cursor: pointer;
}
.propic-wrapper {
  width: 14.4rem;
  height: 14.4rem;
  border-radius: 50%;
  overflow: hidden;
}
.candidate {
  padding: 2rem 0;

  cursor: pointer;
}
.candidate-synopsis {
  padding: 1.4rem 1.5rem;
}
/*.name{*/
/*font-size: 1.6rem;*/
/*text-align: left;*/
/*font-weight: 600;*/
/*}*/
.gender {
  font-size: 1.4rem;
  text-align: left;
  font-weight: 400;
}
.status {
  font-size: 1.2rem;
  text-align: left;
  font-weight: 300;
  color: #808080;
}
.ico-but {
  padding: 1.4rem 0;
}
.citm {
  cursor: pointer;
}
.citm:hover .propic {
  transform: scale(1.05);
  transition: 0.4s;
}
.candidate:hover {
  border-bottom: 0.1rem solid #f7f7f7;
}
.candidate-card-wrapper {
  width: 100%;
  padding: 1.6rem;
  background-color: #ffffff;
  position: relative;
  box-shadow: 0rem 0rem 0.5rem lightgrey;
  color: #4c4f5d;
  border-radius: 0.4rem;
  transition: 0.5s;
  min-height: 22rem;
}
.candidate-card-wrapper:hover {
  box-shadow: 0rem 0rem 1rem lightgrey;
  transition: 0.5s;
}
.candidate-card {
  height: 100%;
}
.information {
  text-align: left;
}
.information-prog {
  text-align: left;
  margin: 0 1rem 2rem 0;
}
/* .action-buttons {
  position: absolute;
  bottom: 0;
  margin: 1.0rem 0 !important;
  color: #f7472f;
} */
/* .action-button-fav {
  position: absolute;
  bottom: 0;
  right: 1.0rem;
  margin: 1.0rem 0 !important;
  color: #11998e;
} */
/* .action-button-contact {
  position: absolute;
  bottom: 0;
  right: 8.0rem;
  margin: 1.0rem 0 !important;
  color: #05344c;
} */
/* .small-chips {
  padding: .2rem .5rem;
  border: .1rem solid #05344c;
  margin-right: .5rem;
} */
.message-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.item {
  font-size: 1.4rem;
  text-align: left;
  color: #050405;
}
.name {
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 1.5;
  color: #050405;
  cursor: pointer;
}
.name:hover {
  text-decoration: underline;
}
.position {
  font-size: 1.6rem;
  line-height: 1.25;
}
.company {
  font-size: 1.4rem;
  line-height: 1.25;
}
.app-status {
  position: absolute;
  bottom: 1.5rem;
  font-size: 1.4rem;
}
.capsule {
  border-radius: 0.2rem;
  padding: 0.3rem 1rem;
  font-weight: bold;
  width: 100%;
}
.shortListed {
  border: 0.1rem solid #0766ff;
  color: #0766ff;
}
.rejected {
  border: 0.1rem solid #f7472f;
  color: #f7472f;
}
</style>
